import card1 from '../../../assets/images/design-card/cards/SINFOTO/card-1.png'
import card2 from '../../../assets/images/design-card/cards/SINFOTO/card-2.png'
import card3 from '../../../assets/images/design-card/cards/SINFOTO/card-3.png'
import card4 from '../../../assets/images/design-card/cards/SINFOTO/card-4.png'
import card5 from '../../../assets/images/design-card/cards/SINFOTO/card-5.png'
import card6 from '../../../assets/images/design-card/cards/SINFOTO/card-6.png'
import card7 from '../../../assets/images/design-card/cards/SINFOTO/card-7.png'
import card8 from '../../../assets/images/design-card/cards/SINFOTO/card-8.png'

import pre_card1 from '../../../assets/images/design-card/cards/CONFOTO/card-1.png'
import pre_card2 from '../../../assets/images/design-card/cards/CONFOTO/card-2.png'
import pre_card3 from '../../../assets/images/design-card/cards/CONFOTO/card-3.png'
import pre_card4 from '../../../assets/images/design-card/cards/CONFOTO/card-4.png'
import pre_card5 from '../../../assets/images/design-card/cards/CONFOTO/card-5.png'
import pre_card6 from '../../../assets/images/design-card/cards/CONFOTO/card-6.png'
import pre_card7 from '../../../assets/images/design-card/cards/CONFOTO/card-7.png'
import pre_card8 from '../../../assets/images/design-card/cards/CONFOTO/card-8.png'

import arg_card1 from '../../../assets/images/design-card/cards/SINFOTO/arg/card-1.png'
import arg_card2 from '../../../assets/images/design-card/cards/SINFOTO/arg/card-2.png'
import arg_card3 from '../../../assets/images/design-card/cards/SINFOTO/arg/card-3.png'
import arg_card4 from '../../../assets/images/design-card/cards/SINFOTO/arg/card-4.png'
import arg_card5 from '../../../assets/images/design-card/cards/SINFOTO/arg/card-5.png'
import arg_card6 from '../../../assets/images/design-card/cards/SINFOTO/arg/card-6.png'
import arg_card7 from '../../../assets/images/design-card/cards/SINFOTO/arg/card-7.png'
import arg_card8 from '../../../assets/images/design-card/cards/SINFOTO/arg/card-8.png'

import pre_arg_card1 from '../../../assets/images/design-card/cards/CONFOTO/arg/card-1.png'
import pre_arg_card2 from '../../../assets/images/design-card/cards/CONFOTO/arg/card-2.png'
import pre_arg_card3 from '../../../assets/images/design-card/cards/CONFOTO/arg/card-3.png'
import pre_arg_card4 from '../../../assets/images/design-card/cards/CONFOTO/arg/card-4.png'
import pre_arg_card5 from '../../../assets/images/design-card/cards/CONFOTO/arg/card-5.png'
import pre_arg_card6 from '../../../assets/images/design-card/cards/CONFOTO/arg/card-6.png'
import pre_arg_card7 from '../../../assets/images/design-card/cards/CONFOTO/arg/card-7.png'
import pre_arg_card8 from '../../../assets/images/design-card/cards/CONFOTO/arg/card-8.png'

import circuloImg from '../../../assets/images/design-card/circulo.svg'
import arbolImg from '../../../assets/images/design-card/arbol.svg'
import estrellaImg from '../../../assets/images/design-card/estrella.svg'
import corazonImg from '../../../assets/images/design-card/corazon.svg'

import marca1 from '../../../assets/images/design-card/marca-agua.png'
import marca2 from '../../../assets/images/design-card/marca-agua-v.png'
import { TROPICALIZED } from '../../../constants/activity-constants'

const shapes = {
  circle: {
    image: circuloImg,
    props: {
      x: 118.48,
      y: 290.81,
      w: 629.26,
      h: 629.26,
    },
  },
  tree: {
    image: arbolImg,
    props: {
      x: 167.74,
      y: 275.1,
      w: 530.74,
      h: 695.03,
    },
  },
  star: {
    image: estrellaImg,
    props: {
      x: 100.8,
      y: 278.21,
      w: 666.61,
      h: 631.47,
    },
  },
  heart: {
    image: corazonImg,
    props: {
      x: 120.63,
      y: 293.17,
      w: 625.39,
      h: 561.64,
    },
  },
}

export const cardsStore = [
  {
    image: TROPICALIZED ? arg_card1 : card1,
    preview: TROPICALIZED ? pre_arg_card1 : pre_card1,
    mask: shapes.circle,
  },
  {
    image: TROPICALIZED ? arg_card2 : card2,
    preview: TROPICALIZED ? pre_arg_card2 : pre_card2,
    mask: shapes.tree,
  },
  {
    image: TROPICALIZED ? arg_card3 : card3,
    preview: TROPICALIZED ? pre_arg_card3 : pre_card3,
    mask: shapes.star,
  },
  {
    image: TROPICALIZED ? arg_card4 : card4,
    preview: TROPICALIZED ? pre_arg_card4 : pre_card4,
    mask: shapes.tree,
  },
  {
    image: TROPICALIZED ? arg_card5 : card5,
    preview: TROPICALIZED ? pre_arg_card5 : pre_card5,
    mask: shapes.heart,
  },
  {
    image: TROPICALIZED ? arg_card6 : card6,
    preview: TROPICALIZED ? pre_arg_card6 : pre_card6,
    mask: shapes.circle,
  },
  {
    image: TROPICALIZED ? arg_card7 : card7,
    preview: TROPICALIZED ? pre_arg_card7 : pre_card7,
    mask: shapes.circle,
  },
  {
    image: TROPICALIZED ? arg_card8 : card8,
    preview: TROPICALIZED ? pre_arg_card8 : pre_card8,
    mask: shapes.circle,
  },
]

export const marcasDeAgua = [marca1, marca2]
